import { useParams, Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { waLink } from "../constants/data";

export default function OrderSuccess() {
  const { id } = useParams();
  return (
    <div className="pt-32 pb-20 min-h-[60vh]" data-testid="order-success-page">
      <div className="container-x max-w-2xl text-center">
        <CheckCircle className="w-16 h-16 mx-auto text-[#7A1F2B]" strokeWidth={1}/>
        <h1 className="font-serif text-5xl text-[#2D2424] mt-6">Thank you!</h1>
        <p className="text-[#5C5555] mt-4">Your order <span className="font-medium text-[#7A1F2B]">#{id?.slice(0, 8)}</span> has been received.</p>
        <p className="text-[#5C5555] mt-2">We'll reach out on WhatsApp shortly to confirm delivery details.</p>
        <div className="flex flex-wrap gap-3 justify-center mt-8">
          <Link to="/" data-testid="success-home-btn" className="btn-secondary">Back to Home</Link>
          <a href={waLink(`Hi! Just placed order #${id?.slice(0,8)}`)} target="_blank" rel="noreferrer" className="btn-whatsapp">Message us on WhatsApp</a>
        </div>
      </div>
    </div>
  );
}
